import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  changes: {},
  changesAdvanceDetected: false,
  isBan: false,
};

const changeAdvanceDetectedSlice = createSlice({
  name: 'changeAdvanceDetected',
  initialState,
  reducers: {
    addChange: (state, action) => {
      state.changes = {
        ...state.changes, 
        [action.payload.key]: action.payload.value
      };
    },
    clearChanges: (state) => {
      state.changes = {};
    },
    setChangesDetected: (state, action) => {
      state.changesAdvanceDetected = action.payload;
    },
    setIsBan: (state, action) => {
      state.isBan = action.payload;
    }
  },
});

export const { addChange, clearChanges, setChangesDetected, setIsBan } = changeAdvanceDetectedSlice.actions;
export const changeAdvanceDetected = changeAdvanceDetectedSlice.reducer;
